import React, { useEffect, useState } from 'react';
import './SubmitOrder.scss';
import { useTranslation } from 'react-i18next';
import useHttp from 'utils/hooks/useHttp';
import { notify } from 'utils/marketplace';
import Spinner from 'components/spinner/Spinner';
import { setReloadOrderList } from 'store/slices/proformaAutomotorModal.slice';
import { useDispatch } from 'react-redux';

type Props = {
  setOpenModal: (e: boolean) => void;
  setStepModal: (e: string) => void;
  stepModalNext: string;
};


const SubmitOrder: React.FC<Props> = (props) => {

  const [isLoadingSendProforma, setIsLoadingSendProforma] = useState<boolean>(true);
  const { t } = useTranslation();
  const http = useHttp();
  let isMounted = true;
  const dispatch = useDispatch();

  useEffect(() => {
    if (isMounted && props.stepModalNext === 'SubmitOrder') {
      onOrderSubmit();
    }

    return () => {
      isMounted = false;
    };


  }, [props.stepModalNext]);

  const onOrderSubmit = async () => {

    const proformaFileFinal = JSON.parse(localStorage.getItem('proformaFileInProgress') as string);

    setIsLoadingSendProforma(true);

    proformaFileFinal.rows = proformaFileFinal.order_items;
    proformaFileFinal.estimation = proformaFileFinal.order_items_estimation;
    http.proforma
      .sendproformaAndEstimationV3(proformaFileFinal)

      .catch((e) => {
        if (e?.message) {
          notify(t(e.message), 'error');
        } else {
          notify(t('_something_went_wrong'), 'error');
        }

        props.setOpenModal(false);
      })
      .finally(() => {
        setIsLoadingSendProforma(false);
        props.setStepModal('Default');
        dispatch(setReloadOrderList(true));
      });
  };


  return (
    <div className="validation-submit-order" >

      <div className="validation-customer-modal-body">
        {isLoadingSendProforma ?

          <div className="validation-customer-modal-row">
            <div className="confirmation-container">
              <div className="confirmation-icon">
                <Spinner class="small" />
              </div>
              <div className="confirmation-title">
                {t('_send_order_in_progress')}
              </div>
            </div>
          </div>

          :
          null
        }
      </div>
    </div >
  );

};

SubmitOrder.displayName = 'SubmitOrder';

export default SubmitOrder;